// extracted by mini-css-extract-plugin
module.exports = {"dialogScheduleItemServiceTime":"DialogScheduleService_dialogScheduleItemServiceTime_3utgz"};